import type {
  WhatsappClaimPreview,
  WhatsappLinkCode,
  WhatsappLinkStatus,
} from '@repo/contracts';

import { apiFetch } from '../api/client';

export const whatsappKeys = {
  all: ['whatsapp'] as const,
  claim: (token: string) => [...whatsappKeys.all, 'claim', token] as const,
  link: () => [...whatsappKeys.all, 'link'] as const,
};

export function fetchWhatsappLink(): Promise<WhatsappLinkStatus> {
  return apiFetch<WhatsappLinkStatus>('/whatsapp/link');
}

export function createWhatsappCode(): Promise<WhatsappLinkCode> {
  return apiFetch<WhatsappLinkCode>('/whatsapp/link/code', { method: 'POST' });
}

export function previewWhatsappClaim(
  token: string,
): Promise<WhatsappClaimPreview> {
  return apiFetch<WhatsappClaimPreview>('/whatsapp/link/claim/preview', {
    body: JSON.stringify({ token }),
    method: 'POST',
  });
}

export function claimWhatsappLink(token: string): Promise<WhatsappLinkStatus> {
  return apiFetch<WhatsappLinkStatus>('/whatsapp/link/claim', {
    body: JSON.stringify({ token }),
    method: 'POST',
  });
}

export function unlinkWhatsapp(): Promise<void> {
  return apiFetch<void>('/whatsapp/link', { method: 'DELETE' });
}

/** `+447700900123` → `+44 7700 900123`-ish: grouped for reading, never
 *  parsed back. */
export function displayPhone(phone: string): string {
  const digits = phone.replace(/^\+/, '');
  const country = digits.length > 10 ? digits.slice(0, digits.length - 10) : '';
  const rest = digits.slice(country.length);
  return `+${country ? `${country} ` : ''}${rest.slice(0, 4)} ${rest.slice(4)}`.trim();
}

/** The chat with Floto, opened in WhatsApp. */
export function chatUrl(flotoNumber: string): string {
  return `https://wa.me/${flotoNumber.replace(/^\+/, '')}`;
}
